/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maca_CloseInputs */

const en_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const ar_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق`)
};

const bn_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বন্ধ করুন`)
};

const de_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const es_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const fr_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const pt_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const zh_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const tr_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapat`)
};

const ru_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть`)
};

const pl_maca_close = /** @type {(inputs: Maca_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Maca_CloseInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const maca_close = /** @type {((inputs?: Maca_CloseInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maca_CloseInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_maca_close(inputs)
	if (locale === "bn") return bn_maca_close(inputs)
	if (locale === "de") return de_maca_close(inputs)
	if (locale === "es") return es_maca_close(inputs)
	if (locale === "fr") return fr_maca_close(inputs)
	if (locale === "pt") return pt_maca_close(inputs)
	if (locale === "zh") return zh_maca_close(inputs)
	if (locale === "tr") return tr_maca_close(inputs)
	if (locale === "ru") return ru_maca_close(inputs)
	if (locale === "pl") return pl_maca_close(inputs)
	return en_maca_close(inputs)
});